export const CREATE_PUBLIC_HOLIDAY = "CREATE_PUBLIC_HOLIDAY";
export const FETCH_PUBLIC_HOLIDAYS = "FETCH_PUBLIC_HOLIDAYS";
export const FETCH_PUBLIC_HOLIDAY = "FETCH_PUBLIC_HOLIDAY";
export const EDIT_PUBLIC_HOLIDAY = "EDIT_PUBLIC_HOLIDAY";
export const DELETE_PUBLIC_HOLIDAY = "DELETE_PUBLIC_HOLIDAY";
